import { takeEvery, all, call, put, cancelled } from 'redux-saga/effects';

import {
  SALESGOALS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  SALESGOALS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  SALESGOALS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  salesGoalsMassiveUploadSetAllowUpload,
  salesGoalsMassiveUploadClearAllowUpload,
  salesGoalsMassiveUploadSetVerify,
  salesGoalsMassiveUploadClearVerify,
  salesGoalsMassiveUploadClearUpload,
} from '../actions';

import instance from 'services/request';

import { responseOK } from 'Domains/SalesChallengeRefactor/utils';

import { salesGoalsMassiveUpload } from '../../services';
import {
  fileTo64String,
  validateTypeAndSize,
  summaryModal,
  summaryEndModal,
} from 'common/MassiveUploads/utils';
import { messageError } from 'utils/messages';

function* workSalesGoalsMassiveUploadSetAllowUpload(action) {
  try {
    yield salesGoalsMassiveUploadSetAllowUpload(action.payload);
  } catch (error) {
    yield salesGoalsMassiveUploadClearAllowUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield salesGoalsMassiveUploadClearAllowUpload();
    }
  }
}

function* workSalesGoalsMassiveUploadRequestVerify({ payload }) {
  const { file, setFileString } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const isValidFile = validateTypeAndSize(file);
    if (!isValidFile) {
      messageError(
        'El formato del archivo de carga masiva de metas de venta debe ser .xlsx y tener un tamaño máximo de 20 MB.'
      );

      return;
    }

    const file64Str = yield call(fileTo64String, file);
    yield call(setFileString, file64Str);
    const response = yield call(salesGoalsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: file64Str,
        overwrite: false,
        save: false,
      },
    });
    if (responseOK(response)) {
      let { data, message, allCorrectMessage } = response;
      let allCorrect = data.correct > 0 && data.totalErrors === 0;
      if (allCorrect) {
        data.allCorrectMessage = allCorrectMessage;
      }
      yield put(salesGoalsMassiveUploadSetVerify(data));
      yield call(summaryModal, message);
    } else {
      yield put(salesGoalsMassiveUploadClearVerify());
    }
  } catch (error) {
    yield salesGoalsMassiveUploadClearVerify();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield salesGoalsMassiveUploadClearVerify();
      source.cancel('cancelled Request');
    }
  }
}

function* workSalesGoalsMassiveUploadRequestUpload({ payload }) {
  const { history, fileString, overwrite } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const response = yield call(salesGoalsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: fileString,
        save: true,
        overwrite,
      },
    });
    if (responseOK(response)) {
      /* yield call(messageSuccess, response.message);
      yield call(history.push, '/dashboard');*/
      yield call(summaryEndModal, response.data, history, '/catalog/selling-goals');
    } else {
      yield put(salesGoalsMassiveUploadClearUpload());
    }
  } catch (error) {
    yield salesGoalsMassiveUploadClearUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield salesGoalsMassiveUploadClearUpload();
      source.cancel('cancelled Request');
    }
  }
}

export function* watchSalesGoalsMassiveUploadSetAllowUpload() {
  yield all([
    takeEvery(
      SALESGOALS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
      workSalesGoalsMassiveUploadSetAllowUpload
    ),
  ]);
}

export function* watchSalesGoalsMassiveUploadRequestVerify() {
  yield all([
    takeEvery(SALESGOALS_MASSIVE_UPLOAD_REQUEST_VERIFY, workSalesGoalsMassiveUploadRequestVerify),
  ]);
}

export function* watchSalesGoalsMassiveUploadRequestUpload() {
  yield all([
    takeEvery(SALESGOALS_MASSIVE_UPLOAD_REQUEST_UPLOAD, workSalesGoalsMassiveUploadRequestUpload),
  ]);
}
